"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHomeDeliveryFeeRange = void 0;
var _models = require("../models");
const getHomeDeliveryFeeRange = (deliveryMethods, lastHomeDeliveryFee) => {
  const homeDeliveryMethod = deliveryMethods.find(deliveryMethod => deliveryMethod.type === _models.AddressItemDeliveryMethod.Home);
  if (homeDeliveryMethod?.minFee == null && homeDeliveryMethod?.maxFee == null) {
    return {
      minFee: undefined,
      maxFee: undefined
    };
  }
  const minFee = Math.min(homeDeliveryMethod.minFee ?? Number.POSITIVE_INFINITY, lastHomeDeliveryFee ?? Number.POSITIVE_INFINITY);
  return {
    minFee: minFee === Number.POSITIVE_INFINITY ? undefined : minFee,
    maxFee: homeDeliveryMethod.maxFee
  };
};
exports.getHomeDeliveryFeeRange = getHomeDeliveryFeeRange;